var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"position-fixed fixed-top rounded-0 w-300",staticStyle:{"z-index":"2000"},attrs:{"show":_vm.dismissCountDown,"dismissible":"","fade":"","variant":_vm.variant},on:{"dismiss-count-down":_vm.countDownChanged,"dismissed":function($event){return _vm.dismissed()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }